import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ControlPanelMainControlsStyles: SxStyles = {
  controlPanelMainControls: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // backgroundColor: '#dedede',
    marginBottom: getResponsiveSize(15),

    '& .reaction-scores-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      pb: getResponsiveSize(5),
    },

    '& .reaction-score-container': {
      height: getResponsiveSize(24),
      position: 'relative',
      top: '-4px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },

    '& .reaction-score': {
      borderRadius: '30%',
      lineHeight: getResponsiveSize(20),
      padding: getResponsiveSize(3.5),
      width: getResponsiveSize(26),
      height: getResponsiveSize(24),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',

      '& span': {
        fontSize: theme.typography.fs12,
        color: '#ededed',
      },

      '&.correct': {
        backgroundColor: '#46c19f',
      },

      '&.wrong': {
        backgroundColor: '#c14652',
        marginLeft: getResponsiveSize(3.5),
      },
    },

    '& .single-control': {},

    '& .multiple-controls': {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'space-around',
    },

    '& .control': {
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      width: getResponsiveSize(100),

      '&:hover': {
        opacity: 0.8,
      },

      '& .icon': {
        borderRadius: '50%',
        width: getResponsiveSize(65),
        height: getResponsiveSize(65),
        background: 'linear-gradient(-1deg, #517ec5 0%, #6bbbe1 100%)',
        position: 'relative',

        '& .control-svg': {
          width: '100%',
          height: '100%',
        },

        '& .chaos-svg': {
          position: 'relative',
          width: '80%',
          height: '80%',
          top: '36%',
          left: '41%',
          transform: 'translate(-50%, -50%)',
        },
        '& .chaos-off': {
          transform: 'translate(-50%, -50%) scaleX(-1)',
        },
      },

      '& .absolute-text': {
        position: 'absolute',
        fontSize: theme.typography.fs11,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'white',
      },

      '& .text': {
        textAlign: 'center',
        color: '#517ec5',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        width: getResponsiveSize(100),
        lineHeight: 1.2,
        marginTop: getResponsiveSize(5),
        fontSize: theme.typography.fs12,
      },
    },

    '& .small': {
      position: 'relative',
      display: 'flex',

      '& .icon': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: getResponsiveSize(50),
        height: getResponsiveSize(50),

        '& img': {
          width: getResponsiveSize(35),
          height: getResponsiveSize(35),
        },

        '& .answers': {
          top: '5%',
          right: '5%',
          position: 'absolute',
          borderRadius: '50%',
          zIndex: 2,
          width: '23%',
          height: '23%',
        },

        '& .right-wrong': {
          backgroundColor: '#46c19f',
        },

        '& .wrong-right': {
          backgroundColor: '#c14652',
        },

        '& .autopilot': {
          height: '60%',
          width: '60%',
        },
      },

      '&.smaller': {
        '& .icon img': {
          width: getResponsiveSize(25),
          height: getResponsiveSize(24),
          marginLeft: getResponsiveSize(4),
        },
      },
    },

    '& .start, & .stop': {
      '& .icon': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },

      '& .text': {
        textAlign: 'center',
        color: '#517ec5',
        width: getResponsiveSize(100),
        lineHeight: 1.2,
      },
    },

    '& .stop .icon': {
      '& img': {
        marginLeft: '0',
        height: getResponsiveSize(30),
        width: getResponsiveSize(30),
      },
    },
  },
};
